import { IInputValidationControllerReturn } from "./InputValidationController";
import InputValidationFun from "./InputValidationFun";
import { EInputValidationResultType } from "./enums/InputValidationEnums";

export interface IInputValidationProps {
  ivc: IInputValidationControllerReturn;
}

export const InputValidation: React.FC<IInputValidationProps> = (props): JSX.Element => {

  return (    
    <div className={"width-inherit pt-1 pb-1 text-sm overflow-hidden remove-on-pdf-create"}> {
      <>
        {(props.ivc.validResultType != EInputValidationResultType.Valid)?
          (props.ivc.isVisible == true) ?
            <div className="flex flex-row">
              <div>
                {InputValidationFun.getIconByType(props.ivc)}
              </div>
              <div className={"ml-1 " + InputValidationFun.getTextClassByType(props.ivc)}>
                {props.ivc.message}
              </div>
            </div>
            : <></>:<></>
        }

        {/* hint: alwas display valid icon */}
        {InputValidationFun.getIsValidIcon(props.ivc)}
        
      </>
    }
    </div>
  )
}